<template>
	<div>
		<form v-on:submit.prevent="saveCompany">
			<v-layout row wrap>
				<v-flex md12>
					<p class="title-form pt-0 mb-0">Idioma del administrador</p>
				</v-flex>
				<v-flex md3>
					<v-select
						class="filter-select"
						v-bind:items="languages"
						item-text="name"
						item-value="id"
						v-model="model.language_id"
						hide-details
						label="Idiomas"
						single-line
						bottom>
					</v-select>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-3>
				<v-flex md6 body-border-right pr-3>
					<v-layout column mb-2>
						<v-flex md12>
							<p class="title-form pt-0 mb-0">Nombre de empresa</p>
						</v-flex>
						<v-flex md12>
							<v-text-field
								type="text"
								class="input-border-inset"
								placeholder="Nombre de empresa"
								v-model="model.company_name">
							</v-text-field>
						</v-flex>
					</v-layout>
					<v-layout column mb-2>
						<v-flex md12>
							<p class="title-form pt-0 mb-0">Dirección</p>
						</v-flex>
						<v-flex md12>
							<v-text-field
								type="text"
								class="input-border-inset"
								placeholder="Dirección"
								v-model="model.address">
							</v-text-field>
						</v-flex>
					</v-layout>
					<v-layout column pb-3>
						<v-flex md12>
							<p class="title-form pt-0 mb-0">Correo electrónico</p>
						</v-flex>
						<v-flex md12>
							<v-text-field
								type="email"
								class="input-border-inset"
								placeholder="Nombre de empresa"
								v-model="model.email">
							</v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md6 pl-3>
					<v-layout column mb-2>
						<v-flex md12>
							<p class="title-form pt-0 mb-0">Número tributario</p>
						</v-flex>
						<v-flex md12>
							<v-text-field
								type="number"
								class="input-border-inset"
								placeholder="Número tributario"
								v-model="model.ruc">
							</v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row wrap mb-2>
						<v-flex md6>
							<p class="title-form pt-0 mb-0">País</p>
						</v-flex>
						<v-flex md6>
							<p class="title-form pt-0 mb-0">Ciudad</p>
						</v-flex>
						<v-flex md6>
							<v-select
								class="filter-select"
								v-bind:items="countries"
								item-text="name"
								item-value="id"
								v-model="model.cms_country_id"
								hide-details
								label="País"
								single-line
								bottom>
							</v-select>
						</v-flex>
						<v-flex md6>
							<v-select
								class="filter-select"
								v-bind:items="citiesByCountry"
								item-text="name"
								item-value="id"
								v-model="model.city_id"
								:disabled="!model.cms_country_id"
								hide-details
								label="Ciudad"
								single-line
								bottom>
							</v-select>
						</v-flex>
					</v-layout>
					<v-layout column pb-3>
						<v-flex md12>
							<p class="title-form pt-0 mb-0">Web</p>
						</v-flex>
						<v-flex md12>
							<v-text-field
								type="text"
								class="input-border-inset"
								placeholder="Dirección web"
								v-model="model.website">
							</v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap body-border-top body-border-bottom>
				<v-flex md6 body-border-right pr-3>
					<v-layout column pb-3 pt-2>
						<v-flex md12>
							<p class="title-form pt-0 mb-0">Datos del contacto</p>
						</v-flex>
						<v-flex md12>
							<v-text-field
								type="text"
								class="input-border-inset"
								placeholder="Nombre del contacto"
								v-model="model.contact_name">
							</v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md6 pl-3>
					<v-layout row wrap pb-3 pt-2>
						<v-flex md6>
							<p class="title-form pt-0 mb-0">Correo electrónico</p>
						</v-flex>
						<v-flex md6>
							<p class="title-form pt-0 mb-0">Teléfono</p>
						</v-flex>
						<v-flex md6>
							<v-text-field
								type="email"
								class="input-border-inset"
								placeholder="Correo electrónico"
								v-model="model.contact_email">
							</v-text-field>
						</v-flex>
						<v-flex md6>
							<v-text-field
								type="phone"
								class="input-border-inset"
								placeholder="Teléfono"
								v-model="model.phone">
							</v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-4>
				<v-flex md12>
					<p class="title-form pt-0 mb-0">Logo de la compañía</p>
				</v-flex>
				<v-flex md6 pr-3>
					<file-upload-container
						v-bind:image-url="model.url_image"
						v-bind:label-for="'company-logo'"
						v-bind:max-resolution="maxResolution"
						v-bind:min-resolution="minResolution"
						v-on:upload="onUpload">
					</file-upload-container>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-4>
				<v-flex md12>
					<p class="title-form pt-0 mb-0">Elegir los idiomas que aparecerán en los módulos</p>
				</v-flex>
				<v-flex md12>
					<v-layout row wrap>
						<v-flex
							md2
							v-for="language in languages" 
							:key="language.id">
							<v-checkbox
								v-model="model.language_json"
								v-bind:value="language.id"
								hide-details
								class="input-checkbox input-languages">
								<template slot="label">
									<img :src="language.url_image" alt="">
									<span>{{language.name}}</span>
								</template>
							</v-checkbox>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-3>
				<v-flex md12 text-xs-left>
					<v-btn
						type="submit"
						class="btn-save">
						Guardar
					</v-btn>
				</v-flex>
			</v-layout>
		</form>
	</div>
</template>

<script>
	import mixin from '@/shared/mixins';
	import helper from '@/shared/helper';
	import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';

	const helperData = helper.data();
	const helperMethods = helper.methods;

	function created() {
		this.loadData();
	}

	function onUpload(url) {
		this.model.url_image = url;
	}

	async function loadData() {
		const user = helperMethods.getUser();
		const request = [
			this.$http.get(`${process.env.MIDDLEWARE_URL}/poll/datacompany/${user.cmsCompaniesId}`),
			this.$http.get(`${process.env.MIDDLEWARE_URL}/company/search/${user.cmsCompaniesId}`),
		];
		const responses = await Promise.all(request);
		this.countries = responses[0].data.data.countries;
		this.cities = responses[0].data.data.cities;
		this.languages = responses[0].data.data.languages.map((language) => {
			const newLanguage = Object.assign({}, language);
			newLanguage.isSelected = false;
			return newLanguage;
		});
		const model = responses[1].data.data.map((data) => {
			const newData = Object.assign({}, data);
			if (!data.url_image) {
				newData.url_image = helperData.preimageUrl;
			}
			return newData;
		});
		this.model = model[0];
	}

	function citiesByCountry() {
		let cities = [];
		if (this.model.cms_country_id) {
			cities = this.cities.filter(city => city.cms_country_id === this.model.cms_country_id);
		}
		return cities;
	}

	async function saveCompany() {
		if (this.model.language_json.length > 0) {
			await this.$http.post('configuration', this.model);
			this.showNotification('Los datos se guardaron correctamente.', 'success');
		} else {
			this.showNotification('Debe seleccionar al menos un idioma para los módulos.', 'warning');
		}
	}

	export default {
		components: {
			FileUploadContainer,
		},
		computed: {
			citiesByCountry,
		},
		created,
		data() {
			return {
				cities: [],
				countries: [],
				languages: [],
				minResolution: 1024,
				maxResolution: 1024,
				model: {
					cms_country_id: 0,
					language_id: '',
					url_image: helperData.preimageUrl,
					language_json: [],
				},
			};
		},
		methods: {
			loadData,
			onUpload,
			saveCompany,
		},
		mixins: mixin,
		name: 'company',
	};
</script>



// WEBPACK FOOTER //
// Company.vue?aceed6d4